import { slicedToArray as _slicedToArray } from '../../../_virtual/_rollupPluginBabelHelpers.esm.js';
import { ShareContext } from '@costar-ui/share-context';
import { createContext } from '@costar-ui/utils';
import React, { useMemo } from 'react';
import PrivateModalManager from './modal-manager.esm.js';

var _createContext = createContext({
    name: 'ModalContext'
  }),
  _createContext2 = _slicedToArray(_createContext, 2),
  ModalProvider = _createContext2[0],
  _useModalContext = _createContext2[1];
var GLOBAL_MODAL_MANAGER = 'csg-global-modal-context';
var ModalContextProvider = function ModalContextProvider(props) {
  var _props$contextId = props.contextId,
    contextId = _props$contextId === void 0 ? GLOBAL_MODAL_MANAGER : _props$contextId,
    children = props.children;
  var existingShareContext = ShareContext.useContext(contextId);
  var context = useMemo(function () {
    if (existingShareContext) {
      return existingShareContext;
    }
    var context = {
      manager: new PrivateModalManager()
    };
    // modal manager is a singleton that will persist through out the life cycle of the browser app
    ShareContext.registerGlobalContext(contextId, context);
    return context;
  }, [contextId, existingShareContext]);
  return /*#__PURE__*/React.createElement(ModalProvider, {
    value: context
  }, children);
};
function useModalContext() {
  var retVal = ShareContext.useContext(GLOBAL_MODAL_MANAGER, _useModalContext);
  return retVal;
}

export { ModalContextProvider, useModalContext };
//# sourceMappingURL=modal-context.esm.js.map
